import React, { ReactNode } from "react";
import classNames from "classnames";

interface Props {
  children: ReactNode;
  className?: string;
}

const Card: React.FC<Props> = ({ className, children }) => {
  return (
    <div className={classNames("rounded-3xl p-2 bg-white", className)}>
      {children}
    </div>
  );
};

export default Card;